// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  createAzureQuotaExtensionAPI,
  AzureQuotaExtensionAPIContext,
  AzureQuotaExtensionAPIOptionalParams,
} from "./azureQuotaExtensionAPIContext.js";
